
import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { FavoriteEstablishmentService } from './service/favorite-establishment.service';
import { AuthService } from '../../../../core/service/auth.service';
import { ConfettiService } from '../../../../shared/confetti/confetti.component';

@Component({
  selector: 'establishment-main-favorite-establihshment',
  imports: [],
  templateUrl: `./favorite-establihshment.component.html`,
  styleUrl: './favorite-establihshment.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoriteEstablihshmentComponent {
  @Input() isFavorite: boolean = false;
  @Input() restaurantId!: number;
  @Output() favoriteToggled = new EventEmitter<boolean>();
  @Input () disabled: boolean = false;

  isLoading: boolean = false;

  private favoriteService = inject(FavoriteEstablishmentService);
  private authService = inject(AuthService);
  private confetti = inject(ConfettiService)

  get isAuthenticated(): boolean {
    return this.authService.isLoggedIn();
  }

  toggleFavorite(event: Event): void {
    event.stopPropagation();

    if (!this.isAuthenticated || this.isLoading) {
      return;
    }

    this.isLoading = true;
    const newFavoriteState = !this.isFavorite;

    if (newFavoriteState) {
      this.favoriteService.disabledEsablishmentFavorite(this.restaurantId).subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response.status) {
            this.confetti.heartsFromSides();
            this.favoriteToggled.emit(true);
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error adding to favorites:', error);
        }
      });
    } else {
      this.favoriteService.enabledEstablishmentFavorite(this.restaurantId).subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response.status) {
            this.favoriteToggled.emit(false);
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error removing from favorites:', error);
        }
      });
    }
  }
}
